import useBuildT from '@/hooks/use-locale'

export function useTranslateData<T, K>(
  data: T,
  callback: (t: ReturnType<typeof useBuildT>, data: T) => K,
) {
  const t = useBuildT()
  return callback(t, data)
}
